//changes2
import React, { useContext, useEffect, useState, useRef } from 'react';
import { HrmStore } from '../../Context/HrmContext';
import Topnav from '../../Components/Topnav';
import ActivityUploadModal from '../../Components/Modals/ActivityUploadModal';
import ActivityDataTable from '../../Components/ActivityComponents/ActivityDataTable';
import axios from 'axios';
import { port } from '../../App';
import { useNavigate, useParams } from 'react-router-dom';
import BackButton from '../../Components/MiniComponent/BackButton';
import EmpNameCom from '../../Components/MiniComponent/EmpNameCom';
import { toast } from 'react-toastify';
import { Dropdown } from 'react-bootstrap';
import ActivityDashboard from './ActivityDashboard';
import InterviewActivityDashboard from '../../Components/ActivityComponents/InterviewActivityDashboard';
import InterviewDataSection from '../../Components/ActivityComponents/InterviewDataSection';
import QRCodeModal from '../../Components/Modals/QRCodeModal';
import { QrCode, DownloadCloud, UploadCloud, PlusCircle } from 'lucide-react';


const generateDates = (month, year) => {
    const dates = [];
    const date = new Date(year, month, 1);

    while (date.getMonth() === month) {
        const day = String(date.getDate()).padStart(2, '0');
        const monthFormatted = String(date.getMonth() + 1).padStart(2, '0');
        const yearFormatted = date.getFullYear();
        const formattedDate = `${yearFormatted}-${monthFormatted}-${day}`;
        dates.push(formattedDate);
        date.setDate(date.getDate() + 1);
    }
    return dates;
};


const EmployeeActivitySheet = ({ subpage }) => {
    let { empid } = useParams();
    let { setActivePage, setTopNav, activeEmployee, getActiveEmployee } = useContext(HrmStore);

    const loggedIn = JSON.parse(sessionStorage.getItem('user'));
    const targetEmpId = empid || loggedIn?.EmployeeId;

    const currentDate = new Date();
    const [dates, setDates] = useState(generateDates(currentDate.getMonth(), currentDate.getFullYear()));
    const [month, setMonth] = useState(currentDate.getMonth());
    const [year, setYear] = useState(currentDate.getFullYear());

    const [showActivityModal, setShowActivityModal] = useState(false);
    const [isUploading, setIsUploading] = useState(false);
    const [uploadTrigger, setUploadTrigger] = useState(false);
    const [uploadActivityId, setUploadActivityId] = useState(null);
    const [showQRModal, setShowQRModal] = useState(false);

    const [teamMembers, setTeamMembers] = useState([]);
    const [isLoadingTeam, setIsLoadingTeam] = useState(false);

    const uploadRef = useRef(null);
    const navigate = useNavigate();

    useEffect(() => {
        setActivePage('activity');
        if (!empid) setTopNav('personal');
        else setTopNav('myteam');
        
        if (!activeEmployee || activeEmployee.length === 0) {
            getActiveEmployee();
        }
    }, [empid]);

    useEffect(() => {
        const loggedInEmpId = loggedIn?.EmployeeId;
        if (loggedInEmpId) {
            setIsLoadingTeam(true);
            axios.get(`${port}/root/ems/ReportingTeam/${loggedInEmpId}/`)
                .then(res => {
                    setTeamMembers(res.data || []);
                })
                .catch(err => console.error("Error fetching team members:", err))
                .finally(() => setIsLoadingTeam(false));
        }
    }, [loggedIn?.EmployeeId]);

    const employeeData = activeEmployee?.find((obj) => obj.employee_Id === empid);
    const employeeName = employeeData?.full_name || '';


    const handle_Month_Change = (e) => {
        const selectedYear = parseInt(e.slice(0, 4));
        const selectedMonth = parseInt(e.slice(5, 7)) - 1;
        setYear(selectedYear);
        setMonth(selectedMonth);

        const newDates = generateDates(selectedMonth, selectedYear);
        setDates(newDates);
    };


    const handleDownloadTemplate = (activityId) => {
        const url = `${port}/root/download-activity-template?activity_list_id=${activityId}`;
        window.location.href = url;
    };


    const triggerUpload = (activityId) => {
        setUploadActivityId(activityId);
        uploadRef.current.click();
    };


    const handleBulkUpload = async (event) => {
        const file = event.target.files[0];
        if (!file || !uploadActivityId) return;

        setIsUploading(true);

        const uploaderId = empid ? empid : loggedIn?.EmployeeId;

        const formData = new FormData();
        formData.append('file', file);

        try {
            const response = await axios.post(
                `${port}/root/bulk-activity-upload?activity_list_id=${uploadActivityId}&login_emp_id=${uploaderId}`,
                formData,
                { headers: { 'Content-Type': 'multipart/form-data' } }
            );

            toast.success(response.data.message || "File uploaded successfully!");
            setUploadTrigger(prev => !prev);

        } catch (error) {
            toast.error(`Upload Failed: ${error.response?.data?.error || 'Unknown error'}`);
        } finally {
            setIsUploading(false);
            event.target.value = null;
        }
    };


    return (
        <div>
            {!subpage && <Topnav name={`Activity Sheet`} />}

            <main className='p-2 poppins'>
                <ActivityDashboard 
                    targetEmpId={empid} 
                    employeeName={employeeName} 
                    headerLeft={
                        <div className="flex flex-wrap items-center gap-2">
                            {/* {empid && <BackButton />} */}
                            {empid && employeeName && (
                                <div className="px-2 py-1 font-semibold text-slate-800 text-sm whitespace-nowrap">
                                    Employee : 
                                    {/* Employee: <span className="text-[#1E4AE8] font-bold">{employeeName} ({empid})</span> */}
                                </div>
                            )}

                            {teamMembers && teamMembers.length > 0 && (
                                <select
                                    className="bg-slate-50 border border-slate-200 rounded-xl px-1 py-1 shadow-sm text-sm font-bold text-slate-700 outline-none max-w-[140px]"
                                    value={empid || ''}
                                    onChange={(e) => {
                                        const selectedId = e.target.value;
                                        if (selectedId) {
                                            navigate(`/activity/myteam/${selectedId}`);
                                        } else {
                                            navigate(`/activity/`);
                                        }
                                    }}
                                >
                                    <option value="">My Dashboard</option>
                                    {teamMembers
                                        .filter(member => member.Designation === 'Recruiter')
                                        .map(member => (
                                            <option key={member.employee_Id} value={member.employee_Id}>
                                                {member.full_name}
                                            </option>
                                        ))
                                    }
                                </select>
                            )}
                        </div>
                    }
                    headerRight={
                        <div className='flex items-center gap-2 flex-wrap'>
                            <button
                                onClick={() => setShowQRModal(true)}
                                className='btn btn-info rounded p-1.5'
                                title="QR Code"
                            >
                                <QrCode size={20} />
                            </button>
                            
                            <input
                                type="file"
                                ref={uploadRef}
                                onChange={handleBulkUpload}
                                style={{ display: 'none' }}
                                accept=".csv, .xlsx"
                            />

                            <Dropdown>
                                <Dropdown.Toggle variant="success" className='greenbtn p-1.5 d-flex align-items-center justify-content-center' title="Download Template">
                                    <DownloadCloud size={20} />
                                </Dropdown.Toggle>
                                <Dropdown.Menu>
                                    <Dropdown.Item onClick={() => handleDownloadTemplate(1)}>Interview Calls</Dropdown.Item>
                                    <Dropdown.Item onClick={() => handleDownloadTemplate(3)}>Client Calls</Dropdown.Item>
                                </Dropdown.Menu>
                            </Dropdown>

                            <Dropdown>
                                <Dropdown.Toggle variant="secondary" className='greybtn p-1.5 d-flex align-items-center justify-content-center' disabled={isUploading} title="Bulk Upload">
                                    {isUploading ? <div className="spinner-border spinner-border-sm" role="status"></div> : <UploadCloud size={20} />}
                                </Dropdown.Toggle>
                                <Dropdown.Menu>
                                    <Dropdown.Item onClick={() => triggerUpload(1)}>Upload Interviews</Dropdown.Item>
                                    <Dropdown.Item onClick={() => triggerUpload(3)}>Upload Client Calls</Dropdown.Item>
                                </Dropdown.Menu>
                            </Dropdown>

                            {(!empid || empid === loggedIn?.EmployeeId) && (
                                <button
                                    onClick={() => setShowActivityModal(true)}
                                    className='bluebtn rounded p-1.5 d-flex align-items-center justify-content-center'
                                    title="Add Activity"
                                >
                                    <PlusCircle size={20} />
                                </button>
                            )}
                        </div>
                    }
                />

                <ActivityUploadModal
                    empid={empid}
                    show={showActivityModal}
                    setshow={setShowActivityModal}
                />

                {empid && <EmpNameCom empid={empid} />}

                <div className="my-3">
                    <input
                        type="month"
                        className='p-2 bgclr rounded outline-none'
                        value={`${year}-${String(month + 1).padStart(2, '0')}`}
                        onChange={(e) => handle_Month_Change(e.target.value)}
                    />
                </div>

                <ActivityDataTable
                    getTrigger={uploadTrigger}
                    loginEmpId={loggedIn?.EmployeeId || JSON.parse(sessionStorage.getItem('dasid'))}
                    targetEmpId={empid}
                    dates={dates}
                    month={month}
                    year={year}
                />

                {/* {empid && (
                    <InterviewActivityDashboard
                        empid={empid}
                        month={month}
                        year={year}
                    />
                )} */}
                <InterviewDataSection
                    getTrigger={uploadTrigger}
                    loginEmpId={loggedIn?.EmployeeId || JSON.parse(sessionStorage.getItem('dasid'))}
                    targetEmpId={empid}
                    dates={dates} month={month} year={year}
                />

                <QRCodeModal
                    show={showQRModal}
                    onHide={() => setShowQRModal(false)}
                    empid={targetEmpId}
                />
            </main>
        </div>
    );
};

export default EmployeeActivitySheet;
